// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__U1EE9","buttons":"PendingPaymentAlert_buttons__16Ow-"};